export enum SignalRSendEvent {
    JoinOAuthGroup,
    LeaveOAuthGroup,
}

export enum SignalRReceiveEvent {
    OAuthComplete,
}